module.exports = __webpack_public_path__ + "assets/img/form-verification-icon2.d7ad58a9.png";